import * as React from 'react';
/**
 *
 * Original name: package
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29923%3A6767
 *
 */
export const PackageLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.253 5.055v5.563h.998v8.134h4.493v-1.5H6.751v-6.633H17.25v6.633h-3.005v1.5h4.506v-8.134h.998V5.055H4.253Zm13.882 4.064v-.001h.113V6.555H5.753v2.563h.252v.001h12.13Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "m14.885 14.98-2.894-2.836-2.876 2.838 1.053 1.068 1.076-1.061v3.762h1.5v-3.77l1.091 1.07 1.05-1.07Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
